const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

function openSmallCart(){
  window.upcartOpenCart();
}

//Show Cart header
// let showCartDrawer = document.querySelector('.show-cart-drawer');
//
// showCartDrawer.addEventListener('click', function(){
//   initCart();
// });

//Close Cart function
// let closeCartDrawer = document.querySelector('.close-cart-drawer');
// closeCartDrawer.addEventListener('click', function(){
//   cartModal.classList.add('hidden');
// });



//Add to cart function
let addToCartButtons = document.querySelectorAll('.add-to-cart-button');
addToCartButtons.forEach(function(button) {
  button.addEventListener('click', function() {
    let planId = null;
    let productContainer = button.closest('.product');
    let selectedVariant;

    selectedVariant = productContainer.querySelector('.product-variant').value;

    if (productContainer.querySelector('input[type="radio"]:checked')) {
      let selectedRadio = productContainer.querySelector('input[type="radio"]:checked');

      if (selectedRadio.classList.contains('subscription')) {
        planId = productContainer.querySelector('.subscription-plan').value;
      }
    }

    let qty = productContainer.querySelector('.qty input[type="text"]').value;

    addItemToCart(selectedVariant, qty, planId);
  });
});

// Add single product
function quickBuyButton(variantId, qty) {
  addItemToCart(variantId, qty, null)
}

function renderCart(cart) {
  let cartEmptyMessage = document.querySelector('.ajax-cart-empty-message');

  if (cart.items.length > 0) {
    cartEmptyMessage.classList.add('hidden');
  } else {
    cartEmptyMessage.classList.remove('hidden');
  }

  cartDrawerContent.innerHTML = '';
  cart.items.forEach(function(item, index) {
    const productTitle = '<div class="ajax-cart-item__title text-blue-shade font-extrabold text-sm leading-4"><a href="'+ item.url +'">' + item.title + '</a></div>';
    const productImage = '<a href="' + item.url + '" class="w-[103px] block"><img class="ajax-cart-item__image w-[103px] shadow-cart-item-shadow bg-white rounded-2xl aspect-square object-contain" src="' + item.image + '" ></a>';

    let compareProductPrice = '';
    let sellingPlan = '';
    let sellingPlanDiscount = '';
    if (item.selling_plan_allocation) {
      sellingPlanDiscount = item.selling_plan_allocation.selling_plan.price_adjustments[0].value;
      sellingPlan = '<div class="font-inter text-xs pt-2">' + 'Subscribe and Save ' + sellingPlanDiscount + '%:' + '<b class="block">' + 'Delivery ' + item.selling_plan_allocation.selling_plan.name + '</b></div>';
      compareProductPrice = item.selling_plan_allocation.compare_at_price;
      compareProductPrice = formatProductPrice(compareProductPrice);
    } else {
      sellingPlan = `
        <div class="font-inter text-xs pt-2">One-Time Purchase</div>
        <div onclick="changeToSubscription(` + item.variant_id + `);" class="cursor-pointer w-full h-[30px] mt-4 px-5 border border-primary-grin rounded-full flex items-center justify-center text-center text-sm text-primary-grin">Subscribe and save 10%</div>
      `;
    }

    const productPrice = '<div class="ajax-cart-item__price text-primary-grin text-sm font-medium flex gap-1">' + formatProductPrice(item.line_price) + '<div class="text-blue-tint line-through">' + compareProductPrice + '</div></div>';
    const productQuantity = '' +
      '<div class="qty h-[40px] w-[80px] rounded-full flex items-center justify-center px-2.5">\n' +
      '<a href="#" data-action="minus">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="2" viewBox="0 0 8 2" fill="none">\n' +
      '  <path d="M7 1H1" stroke="#455189" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '</svg>' +
      '</a>\n' +
      '<input type="text" data-variant-id="' + item.id + '" value="' + item.quantity + '" class="w-full font-inter bg-transparent text-sm text-blue-shade text-center ajax-cart-item__quantity">\n' +
      '<a href="#" data-action="plus">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">\n' +
      '  <path d="M7 4H1" stroke="#455189" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '  <path d="M4 7L4 1" stroke="#455189" stroke-linecap="round" stroke-linejoin="round"/>\n' +
      '</svg></a>\n' +
      '</div>';

    let productRemove = `<a href="#" data-delete-id='${item.id}' class="ajax-cart-item__remove absolute right-0 top-1/4"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_1_1431)">
          <path d="M5.06152 5.06177L14.9381 14.9383" stroke="#D2D4DC" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.9385 5.06177L5.06192 14.9383" stroke="#D2D4DC" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_1_1431">
            <rect width="14.1422" height="14.1422" fill="white" transform="translate(10) rotate(45)"/>
          </clipPath>
        </defs>
      </svg></a>`;

    const concatProductInfo = '<div class="ajax-cart-item__single relative flex gap-5 border-b border-second-grey mx-5 py-5" data-line="' + Number(index + 1) + '">' + productImage + '<div class="w-cart-item-width">' + productTitle + sellingPlan + '<div class="flex justify-between items-center mt-4">' + productQuantity + productPrice + '</div>' + productRemove + '</div>' + '</div>';

    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
  });

  let qtyBlocks = document.querySelectorAll('.qty');
  qtyBlocks.forEach(function(qtyBlock) {
    let input = qtyBlock.querySelector('input[type="text"]');
    let plusBtn = qtyBlock.querySelector('a[href="#"][data-action="plus"]');
    let minusBtn = qtyBlock.querySelector('a[href="#"][data-action="minus"]');

    plusBtn.addEventListener('click', function(e) {
      e.preventDefault();
      let currentValue = parseInt(input.value);
      let newValue = currentValue + 1;
      input.value = newValue > 1 ? newValue : 1;
      let variantID = input.dataset.variantId
      changeProductFromCart(variantID, input.value);
    });

    minusBtn.addEventListener('click', function(e) {
      e.preventDefault();
      let currentValue = parseInt(input.value);
      let newValue = currentValue - 1;
      input.value = newValue > 1 ? newValue : 1;
      let variantID = input.dataset.variantId
      changeProductFromCart(variantID, input.value);
    });
  });

  let removeButtons = document.querySelectorAll('.ajax-cart-item__remove');
  removeButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = button.dataset.deleteId;
      deleteProductFromCart(variantId);
    });
  });

  let total_price = formatProductPrice(cart.total_price);
  document.getElementById('small_cart_total').textContent = total_price;
  initFreeShippingBar(total_price);
}

function addItemToCart(variant_id, qty, selling_plan) {
  let data = {
    "id": variant_id,
    "quantity": qty,
    "selling_plan": selling_plan
  }

  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js');
  xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

  xhr.onload = function () {
    if (xhr.status === 200) {
      initCart();
    } else {
      const errorResponse = JSON.parse(xhr.responseText);
      alert(errorResponse.message + '\r\n' + errorResponse.description);
    }
  };

  xhr.onerror = function (error) {
    console.error('An error occurred:', error);
  };

  xhr.send(JSON.stringify(data));
}

function initCart() {
  // cartModal.classList.remove('hidden');

  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // console.log(data);
      // renderCart(data);
    })
    .catch(error => {
      alert('Error: ' + error.message);
    });
}

function changeToSubscription(variant_id) {
  console.log(variant_id);
}

function changeProductFromCart(variantId, qty) {
  let data = {
    "id": variantId,
    "quantity": qty
  }

  postAjax('/cart/change.js', data, function(data){
    initCart();
  });
}

function deleteProductFromCart(variantId) {
  let data = {
    'id': variantId,
    'quantity': 0,
  };

  postAjax('/cart/change.js', data, function(data){
    initCart();
  });
}

function postAjax(url, data, success) {
  var params = typeof data == 'string' ? data : Object.keys(data).map(
    function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
  ).join('&');

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open('POST', url);
  xhr.onreadystatechange = function() {
    if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(params);
  return xhr;
}

function formatProductPrice(product_price) {
  let money_format = '$';
  let formattedPrice = product_price/100;

  formattedPrice = formattedPrice.toFixed(2);

  if(Shopify.currency.rate != 1.0) {
    formattedPrice = `${formattedPrice} ${Shopify.currency.active}`;
  }else{
    formattedPrice = `$${formattedPrice}`;
  }

  return formattedPrice;
}

function initFreeShippingBar(cart_total_price) {
  var cart_total_without_currency = cart_total_price.replace('$', '');
  var range = freeShipping - parseFloat(cart_total_without_currency);
  var freeShippingBar = document.getElementById('free_shipping_bar');
  var freeShippingDesc = document.querySelector('.free-shipping-desc');
  var freeShippingProgress = document.querySelector('.free-shipping-progress');
  // var calcShippingPrice = document.getElementById('calc_shipping_price');

  if (freeShipping > parseFloat(cart_total_without_currency)) {

    var addText = freeShippingText1.replace('[range]', '$' + range.toFixed(2));

    freeShippingDesc.innerHTML = addText;

    var percent = freeShipping / 100;
    percent = 100 - Math.ceil(range / percent);
    freeShippingProgress.style.width = percent + '%';
    // calcShippingPrice.textContent = 'Next step';
  } else {
    freeShippingDesc.textContent = freeShippingText2;
    freeShippingProgress.style.width = '100%';
    // calcShippingPrice.textContent = 'Free';
  }
}

//QTY function
let qtyBlocks = document.querySelectorAll('.qty');

qtyBlocks.forEach(function(qtyBlock) {
  let input = qtyBlock.querySelector('input[type="text"]');
  let plusBtn = qtyBlock.querySelector('a[href="#"][data-action="plus"]');
  let minusBtn = qtyBlock.querySelector('a[href="#"][data-action="minus"]');

  input.addEventListener('input', function (event) {
    this.value = this.value.replace(/\D/g, '');
  });

  input.addEventListener('keypress', function (event) {
    if (event.key < '0' || event.key > '9') {
      event.preventDefault();
    }
  });

  plusBtn.addEventListener('click', function(e) {
    e.preventDefault();
    let currentValue = parseInt(input.value);
    let newValue = currentValue + 1;
    input.value = newValue > 1 ? newValue : 1;
  });

  minusBtn.addEventListener('click', function(e) {
    e.preventDefault();
    let currentValue = parseInt(input.value);
    let newValue = currentValue - 1;
    input.value = newValue > 1 ? newValue : 1;
  });
});


